import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativesForSonarObject } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const coreSonarObjectsInitiativesGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateSonarObjectReferences([
					{
						initiatives: response.ids,
						sonarObjectId: request.sonarObjectId
					}
				])
		]
	},
	name: 'CoreSonarObjectsInitiatives',
	receive: true,
	request: true,
	requestHandler: getInitiativesForSonarObject
});
